import type { Build } from '@todesktop/shared';
import {
  doc,
  getDoc,
  collection,
  query as firestoreQuery,
  orderBy,
  startAfter as firestoreStartAfter,
  limit as firestoreLimit,
  getDocs,
  QueryConstraint,
} from 'firebase/firestore';
import firestore from './firestore';
import { readQuerySnapshot } from './firestoreData';
import logger from './logger';

export default async function getBuilds({
  addWhereClauses = () => [],
  userId,
  appId,
  limit = 5,
  startAfter,
}: {
  addWhereClauses?: () => QueryConstraint[];
  userId: string;
  appId: string;
  limit?: number;
  startAfter?: string;
}): Promise<Build[]> {
  logger.debug({ appId, limit, startAfter }, 'getBuilds');
  const appRef = doc(firestore, `users/${userId}/applications/${appId}`);
  const appSnapshot = await getDoc(appRef);

  if (!appSnapshot.exists()) {
    throw new Error(`Application with ID of ${appId} doesn't exist.`);
  }

  const buildsCollection = collection(
    firestore,
    `users/${userId}/applications/${appId}/builds`,
  );
  const constraints = [...addWhereClauses(), orderBy('createdAt', 'desc')];

  if (startAfter) {
    constraints.push(firestoreStartAfter(startAfter));
  }

  constraints.push(firestoreLimit(limit));

  const query = firestoreQuery(buildsCollection, ...constraints);
  const buildsResult = await getDocs(query);

  if (buildsResult.empty) {
    return [];
  }

  return readQuerySnapshot<Build>(buildsResult);
}
